import { Button, Checkbox, FormControlLabel, makeStyles, TextField } from '@material-ui/core';
import { lightBlue, teal } from '@material-ui/core/colors';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import * as Actions from '../../Actions';
import { endPoint, getFilteredUsers, univApiCall } from '../../albCommonModule';
import { brtoLf, findDeepPath, getLodingStatus, lfToBr, makeUrlSearchParams } from '../../commonModule';
import { LinksTab, LoadErr, LoadingSpinner } from '../common/commonParts';
import SnackMsg from '../common/SnackMsg';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import { useParams } from 'react-router-dom';
import ContbkUserEdit from './ContbkUserEdit';
import { set } from 'react-hook-form';


const useStyles = makeStyles({
  cntMake: {
    marginTop: 120,
    marginLeft: 480,
    '& .dateInfo': {
      fontSize: '1.25rem',
      marginBottom: 32,
      '& span':{
        fontSize: '1rem',
        '& .riyo':{marginLeft: 8},
      }
    },
    '& .inputTemplate': {
      marginBottom: 32
    }
  },
  usersContacts: {
    '&:hover': {
      cursor: 'pointer',
      '& .editIcon': {
        opacity: 1
      }
    },
    width: '40rem',
    marginBottom: 40,
    '& .editIcon': {
      opacity: 0,
      float: 'right',
      color: teal[800]
    },
    '& .userName': {
      fontSize: '1.25rem',
      borderBottom: `1px ${teal[500]} solid`,
      paddingBottom: 4,
      '& span': {
        fontSize: '1rem',
        paddingLeft: 8
      }
    },
    '& div': {
      marginBottom: 16
    },
  },
  calender: {
    position: 'fixed',
    top: '120px',
    left:'120px',
    backgroundColor: 'white',
    zIndex: 100,
    "& .calenderRow": {
      display: 'flex',
    },
    "& .cell":{
      width: 40, 
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  inputTemplate: {
    marginBottom: 48,
    alignItems: 'center',
    width: "fit-content",
    "& .buttonWrap": {
      textAlign: 'end',
      marginTop: 8,
      "& .canselButton": {
        // color: "#ffffff",
        // backgroundColor: lightBlue[800],
        marginRight: 20,
        marginLeft: 32
      },
    }
  },
  bcMsg: {
    width: 294,
    position: 'fixed',
    top: 480,
    left: 120,
    backgroundColor: 'white',
    '& .buttons': {
      textAlign: 'end',
      marginTop: 8
    }
  }
})

const TestCalender = ({makeDate, setMakeDate, setMakeDay}) => {
  const classes = useStyles();
  const dateList = useSelector(state=>state.dateList);
  if(!dateList.length) return null;
  const dayList = ["日", "月", "火", "水", "木", "金", "土" ];
  const hoge = dateList.reduce((result, dateDt) => {
    const day = dateDt.date.getDay();
    result[day].push(dateDt)
    return result
  }, [...dayList.map(()=>[])]);
  const max_length = hoge.reduce((result, x) => result<x.length ?x.length :result, 0);
  const calenderList = hoge.map((x, index) => 
    x[0].date.getDate() > index+1
      ?x.length+1 < max_length ?[{}, ...x, {}] :[{}, ...x]
      :x.length < max_length ?[...x, {}] :x
  )
  const calenderjei = calenderList.reduce((result, x) => {
    x.forEach((y, index) => result[index].push(y))
    return result
  }, [...calenderList.map(()=>[])]);

  const header_node = dayList.map((dayStr, i) => <div key={"header"+i} className="cell" style={{margin: 1}}>{dayStr}</div>);
  const calender_nodes = calenderjei.map((week, j) => {
    const one_week = week.map((dateDt, i) => {
      const date = dateDt.date ?dateDt.date.getDate() :"";
      const day = dateDt.date ?dayList[dateDt.date.getDay()] :"";
      const holiday = dateDt.holiday ?dateDt.holiday :"";
      const holiday_color = holiday===1?"#f8e3cb" :holiday===2?"#cacad9" :null;
      const selected_styles = makeDate==date ?{borderRadius: '50%', border: `1px ${teal[500]} solid`,} :{};
      return(
        <div style={{backgroundColor: holiday_color, margin: 1}} key={"week"+i}>
          <div
            className="cell"
            style={selected_styles}
            onClick={()=>{setMakeDate(date); setMakeDay(day);}}>
            {date}
          </div>
        </div>
      )
    })

    return(
      <div key={"calenderNode"+j} className='calenderRow'>
        {one_week}
      </div>
    )
  })

  return(
    <div className={classes.calender}>
      <div className='calenderRow'>{header_node}</div>
      <div>{calender_nodes}</div>
    </div>
  )
}

export const CntbkLinksTab = () => {
  const menu = [
    { link: "/contactbook", label: "メッセージ選択" },
    { link: "/contactbook/config", label: "設定" },
    { link: "/contactbook/token", label: "トークン"}
  ];

  return (<LinksTab menu={menu}/>)
}

const InputTemplate = (props) => {
  const {msgDt, contactsDt, makeDate, stdDate, setContactsDt, hid, bid, setSnack} = props;
  const classes = useStyles();
  const [textValue, setTextValue] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [draft, setDraft] = useState(false);
  const handleChange = (event) => {
    setDisabled(event.target.value ?false :true);
    setTextValue(event.target.value);
  }
  const select_date = new Date(parseInt(stdDate.split("-")[0]), parseInt(stdDate.split("-")[1])-1, parseInt(makeDate));
  const c_year = String(select_date.getFullYear());
  const c_month = String(select_date.getMonth()+1).padStart(2, "0");
  const c_date = String(select_date.getDate()).padStart(2, "0");
  const now_time = new Date().getTime();
  const c10h_time = new Date(parseInt(c_year), parseInt(c_month)-1, parseInt(c_date), 10);
  const c20h_time = new Date(parseInt(c_year), parseInt(c_month)-1, parseInt(c_date), 20);
  const otof_disabled = (c10h_time < now_time && now_time < c20h_time) ?false :true;
  const handleClick = async() => {
    const today_list = stdDate.split("-");
    const partOfContact = contactsDt ?JSON.parse(JSON.stringify(contactsDt)) :{};
    const d_date = "D"+today_list[0]+today_list[1]+String(makeDate).padStart(2, "0");
    Object.keys(msgDt).forEach(uid => {
      const msg_list = msgDt[uid];
      msg_list[2].draft = draft;
      if(!msg_list[2].datetime){
        msg_list[2]["content"] = lfToBr(textValue);
      }
      if(!partOfContact[uid]) partOfContact[uid] = {};
      partOfContact[uid][d_date] = msg_list;
    })
    const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(partOfContact)};
    await axios.post(endPoint(), makeUrlSearchParams(parms)).then(res => {
      if(!res.data.result) setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
      else{
        setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
        setContactsDt({...partOfContact});
        setTextValue("");
      }
    });
    // await axios.post(endPoint(), makeUrlSearchParams(parms)).then(res => {
    //   // console.log("sendPartOfContact", res);
    //   if(!res.data.result) setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
    //   else{
    //     setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
    //     setMsgDt({...data});
    //   }
    // });
  }

  const otofDisabledStyle = {marginTop: 8}
  return(
    <div className={classes.inputTemplate}>
      <TextField
        id="templateTextField"
        label="今日の雛形"
        multiline
        minRows={1}
        variant="outlined"
        value={textValue}
        onChange={handleChange}
        style={{width: '40rem'}}
        disabled={otof_disabled}
      />
      {otof_disabled ?<div style={otofDisabledStyle}>当日10時〜20時の間に入力できます。</div> :null}
      <div className="buttonWrap">
        <FormControlLabel
          control={<Checkbox
            label="下書き"
            checked={draft}
            onChange={e => setDraft(e.target.checked)}
            defaultChecked
          />}
          label="下書き"
          labelPlacement="start"
        />
        <Button
          variant='contained'
          className='canselButton'
          style={{color: disabled?null :"#ffffff", backgroundColor: disabled ?null :lightBlue[800]}}
          disabled={disabled}
          onClick={() => setTextValue("")}
        >
          キャンセル
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={disabled}
          onClick={handleClick}
        >
          書き込み
        </Button>
      </div>
    </div>
  )
}

const UsersContacts = ({uid, msgList, hid, bid, user_dt, contactsDt, stdDate, makeDate, setSnack}) => {
  const classes = useStyles();
  const ucontacts_dt = contactsDt[uid] ?contactsDt[uid] :{};
  const [locked, setLocked] = useState(ucontacts_dt.locked ?true :false);
  // let locked = ucontacts_dt.locked ?true :false;
  const handleClick = async() => {
    const fetch_prms = {a: "fetchContacts", hid, bid, date: stdDate};
    const res = await axios.post(endPoint(), makeUrlSearchParams(fetch_prms));
    if(!res.data.result){
      setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
      return;
    }
    const contacts_dt = res.data.dt[0]
      ?res.data.dt[0].contacts
        ?res.data.dt[0].contacts
        :{}
      :{};
    const contacts_by_uid = contacts_dt[uid] ?contacts_dt[uid] :{};
    console.log(contacts_by_uid)
    if(contacts_by_uid.locked){
      setSnack({...{msg: '編集中のため、この利用者を編集できません。', severity: 'warning'}});
      if(!locked) setLocked(true);
      // locked = true;
      return;
    }
    contacts_by_uid["locked"] = true;
    //送信処理
    const c_year = parseInt(stdDate.split("-")[0]);
    const c_month = parseInt(stdDate.split("-")[1])-1;
    const c_date = parseInt(makeDate);
    const calender_date = new Date(c_year, c_month, c_date).getTime();
    const uid_num = uid.replace("UID", "");
    const url = window.origin + `/#/contactbook/${uid_num}/${calender_date}`;
    window.location = url;
  }
  return(
    <div className={classes.usersContacts} onClick={handleClick}>
      <div className='editIcon'>{locked ?<LockIcon /> :<EditIcon />}</div>
      <div className='userName'>{user_dt.name}<span>{user_dt.ageStr}</span></div>
      {msgList.map(((dt, i) => {
        let init_msg = "予期せぬエラー";
        if(i===0) init_msg = "事前送信メッセージ";
        else if(i===1) init_msg = "ご家族様からのメッセージ";
        else if(i===2) init_msg = "事業所からのメッセージ";
        return <div key={i}>{dt.content ?brtoLf(dt.content) :init_msg}</div>
      }))}
    </div>
  )
}

const CntbkMakeMain = (props) => {
  const classes = useStyles();
  const {stdDate, schedule, contactsDt, setContactsDt, users, hid, bid, setSnack, today_list, makeDate, makeDay} = props;
  const [msgDt, setMsgDt] = useState({});

  useEffect(() => {
    const d_date = "D"+today_list[0]+String(today_list[1]).padStart(2, "0")+String(makeDate).padStart(2, "0");
    const today_schedule = Object.keys(schedule).filter(uid => Object.keys(schedule[uid]).some(dDate => dDate===d_date));
    const contacts = JSON.parse(JSON.stringify(contactsDt));
    const msg_dt = Object.keys(contacts).reduce((result, uid) => {
      if(!today_schedule.includes(uid)) return result;
      if(contacts[uid] && contacts[uid][d_date]) result[uid] = contacts[uid][d_date];
      return result
    }, {});
    const nonmsgdt_uids = today_schedule.filter(uid => !Object.keys(msg_dt).includes(uid));

    nonmsgdt_uids.forEach(uid => msg_dt[uid] = [{content: "事業所より"}, {content: ""}, {content: "今日のご様子"}]);
    setMsgDt({...msg_dt});
  }, [contactsDt, makeDate])

  const display_date = `${String(today_list[1]).padStart(2, "0")}/${String(makeDate).padStart(2, "0")}`;
  const eachUsersContacts = Object.keys(msgDt).map((uid,i) => {
    const user_dt = users.find(userDt => "UID"+userDt.uid === uid);
    if(!user_dt || !(user_dt.pmail && user_dt.faptoken)) return null;
    const ucontacts_prms = {uid, msgList: msgDt[uid], hid, bid, contactsDt, user_dt, stdDate, makeDate, setSnack}
    return <UsersContacts key={"usersContacts"+i} {...ucontacts_prms}/>
  }).filter(x => x);

  const inputtemp_parms = {msgDt, contactsDt, setContactsDt, makeDate, stdDate, hid, bid, setSnack}
  return(
    <>
    <div className={classes.cntMake}>
      <div className='dateInfo'>
        {display_date}
        <span>（{makeDay}）</span>
        <span className='riyo'>利用人数{eachUsersContacts.length}人</span>
      </div>
      <InputTemplate className="inputTemplate" {...inputtemp_parms}/>
      <div>
        {eachUsersContacts}
      </div>
    </div>
    </>
  )
}

const FetchErrMsg = () => {
  const style = {marginTop: 200, marginLeft: 200, fontSize: '1.25rem', lineHeight: '1.5rem'}
  return(
    <div style={style}>
      <p style={{marginBottom: 8}}>何も表示されない場合は再読み込みをしてください。</p>
      <p>同じ問題を繰り返す場合は、お手数おかけしますがサポートまで連絡お願いします。</p>
    </div>
  )
}

//11月22日　橋本追加
const BroadcastMessage = ({com, setSnack}) => {
  const classes = useStyles();
  if(!com.ext) com.ext = {};
  const init_msg = com.ext.messagetoall ?brtoLf(com.ext.messagetoall) :"";
  const [originBcMsg, setOriginBcMsg] = useState(init_msg);
  const [bcMsg, setBcMsg] = useState(init_msg);
  const handleClick = async() => {
    const prms = {
      a: "sendComExt",
      hid: com.hid,
      bid: com.bid,
      ext: JSON.stringify({...com.ext, messagetoall: lfToBr(bcMsg)})
    }
    const res = await univApiCall(prms, '', '', setSnack, "書き込みました。", "書き込みに失敗しました。");
    if(res.data.result) setOriginBcMsg(bcMsg)
  }

  return(
    <div className={classes.bcMsg}>
      <TextField
        variant="outlined"
        label="一斉送信メッセージ"
        multiline
        maxRows={4}
        value={bcMsg}
        style={{width: '100%'}}
        onChange={e => setBcMsg(e.target.value)}
      />
      <div className='buttons'>
        <Button
          variant='contained'
          style={{marginRight: 8, backgroundColor: originBcMsg===bcMsg ?null :lightBlue[800], color: originBcMsg===bcMsg ?null :'#fff'}}
          disabled={originBcMsg===bcMsg}
          onClick={() => setBcMsg(init_msg)}
        >
          キャンセル
        </Button>
        <Button
          variant='contained'
          color="primary"
          disabled={originBcMsg===bcMsg}
          onClick={handleClick}
        >
          書き込み
        </Button>
      </div>
    </div>
  )
}

export const CntbkMake = () => {
  const allState = useSelector(state => state);
  const {uid, calenderDate} = useParams();
  const loadingStatus = getLodingStatus(allState);
  const {stdDate, hid, bid, users, schedule, service, classroom, com} = allState;
  const [contactsDt, setContactsDt] = useState({});
  const [snack, setSnack] = useState({});
  const [fetchErr, setFetchErr] = useState(false);
  const [fetched, setFetched] = useState(false);
  const day_list = ["日", "月", "火", "水", "木", "金", "土"];
  const today_list = stdDate.split("-").map(strDate => parseInt(strDate));
  const now = new Date();
  const now_month = now.getMonth() + 1;
  const [makeDate, setMakeDate] = useState(today_list[1]===now_month ?String(now.getDate()).padStart(2, "0") :"01");
  const [makeDay, setMakeDay] = useState(day_list[(today_list[1]===now_month ?now :new Date(today_list[0], today_list[1]-1, 1)).getDay()]);

  useEffect(() => {
    if(!loadingStatus.loaded) return;
    let isMounted = true;
    (async() => {
      const parms = {a: "fetchContacts", hid, bid, date: stdDate};
      // await axios.post("https://houday.rbatos.com/api/apidev.php", makeUrlSearchParams(parms)).then(res => {
      //   if(!res.data.result){
      //     setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
      //     setFetchErr(true);
      //   }else if(isMounted){
      //     setContactsDt({...findDeepPath(res.data.dt[0], ["contacts"], {})});
      //   }
      // })
      const res = await axios.post(endPoint(), makeUrlSearchParams(parms));
      if(!res.data.result){
        setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
        setFetchErr(true);
      }else if(isMounted){
        setContactsDt({...findDeepPath(res.data.dt[0], ["contacts"], {})});
        setFetched(true);
      }
      // await axios.post(endPoint(), makeUrlSearchParams(parms)).then(res => {
      //   if(!res.data.result){
      //     setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
      //     setFetchErr(true);
      //   }else if (isMounted) setContactsDt({...res.data.dt[0]});
      // })
    })();
    return () => {
      isMounted = false
    }
  }, [])

  if(!(loadingStatus.loaded && fetched)){
    return (
      <>
      <CntbkLinksTab />
      <LoadingSpinner/>
      </>
    )
  }else if (loadingStatus.error){
    return (
      <>
      <CntbkLinksTab />
      <LoadErr loadStatus={loadingStatus} errorId={'E4933'} />
      </>
    )
  }
  if(uid) return <ContbkUserEdit uid={uid} calenderDate={calenderDate} contactsDt={contactsDt} setContactsDt={setContactsDt}/>;
  const sort_users = [...users];
  sort_users.sort((a, b) => (parseInt(a.sindex) - parseInt(b.sindex)));
  const filtered_users = getFilteredUsers(sort_users, service, classroom);
  const main_parms = {stdDate, schedule, contactsDt, setContactsDt, users: filtered_users, hid, bid, setSnack, today_list, makeDate, makeDay};
  const calender_parms = {makeDate, setMakeDate, setMakeDay};
  return (
    <>
    <CntbkLinksTab />
    {fetchErr
      ?<FetchErrMsg />
      :<CntbkMakeMain {...main_parms} />}
    <SnackMsg {...snack}/>
    <TestCalender {...calender_parms} />
    <BroadcastMessage com={com} setSnack={setSnack}/>
    </>
  )
}
export default CntbkMake;